/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateFacilityCustomTagRequest
 */
export interface CreateFacilityCustomTagRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateFacilityCustomTagRequest
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateFacilityCustomTagRequest
     */
    facility_ids: Array<string>;
}

/**
 * Check if a given object implements the CreateFacilityCustomTagRequest interface.
 */
export function instanceOfCreateFacilityCustomTagRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "facility_ids" in value;

    return isInstance;
}

export function CreateFacilityCustomTagRequestFromJSON(json: any): CreateFacilityCustomTagRequest {
    return CreateFacilityCustomTagRequestFromJSONTyped(json, false);
}

export function CreateFacilityCustomTagRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFacilityCustomTagRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'facility_ids': json['facility_ids'],
    };
}

export function CreateFacilityCustomTagRequestToJSON(value?: CreateFacilityCustomTagRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'facility_ids': value.facility_ids,
    };
}

